module.exports = __webpack_public_path__ + "img/mln.70e22075.svg";